import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { global } from './api.global';

@Injectable()

export class ProductoService{
	public url: string;
	public numNoti:number=0;

	constructor(public _http: HttpClient){
		this.url = global.url;
	}

	getnumNotifica(){
		return this.numNoti;
	}

	editNotif(valn){
		this.numNoti = valn;
		console.log('actualiza noti: ' + valn)
	}
	//--Registrar Producto--//
	register(token, prod): Observable<any>{
		let json = JSON.stringify(prod);
		let headers = new HttpHeaders().set('Content-Type','application/json')
										.set('Authorization', token);

		return this._http.post(this.url+'prod_register', json, {headers: headers});
	}

	//--Actualizar registro de Producto--//
	update(token, prod): Observable<any>{
		let json = JSON.stringify(prod);
		let headers = new HttpHeaders().set('Content-Type','application/json')
										.set('Authorization', token);

		return this._http.put(this.url+'prod_update', json, {headers: headers});
	}

	//--Actualizar estado de Producto--//
	updatepro(token, prod): Observable<any>{
		let json = JSON.stringify(prod);
		let headers = new HttpHeaders().set('Content-Type','application/json')
										.set('Authorization', token);

		return this._http.put(this.url+'prod_updatepro', json, {headers: headers});
	}

	//--Actualizar porcentaje de descuento para una categoría de Productos--//
	updateDesc(token, dspro): Observable<any>{
		let json = JSON.stringify(dspro);
		let headers = new HttpHeaders().set('Content-Type','application/json')
										.set('Authorization', token);

		return this._http.put(this.url+'prod_updatedesc', json, {headers: headers});
	}

	//--Actualizar imagen de producto--//
	upImage(dataimg): Observable<any>{
		let headers = new HttpHeaders().set('Content-Type','multipart/form-data');

		return this._http.post(this.url+'prod_upimage', dataimg);
	}

    //--Consultar un Producto específico
    getProducto(idpro): Observable<any>{
		let headers = new HttpHeaders().set('Content-Type','application/json');

		return this._http.get(this.url+'prod_showpe/'+idpro, {headers: headers}); 
	}

	//--Consultar inventario por almacen de producto específico
    getDtInvProducto(idpro, ids): Observable<any>{
		let headers = new HttpHeaders().set('Content-Type','application/json');

		return this._http.get(this.url+'prod_showdtalm/'+idpro+'/'+ids, {headers: headers}); 
	}

	//--Consultar stock de un producto por almacen en ventas registradas  
    getProductoStk(idpro, idalm, md): Observable<any>{
		let headers = new HttpHeaders().set('Content-Type','application/json');

		return this._http.get(this.url+'prod_showstk/'+idpro+'/'+idalm+'/'+md, {headers: headers}); 
	}
 
	// Obtener los Productos activos
	getProductoh(): Observable<any>{
		let headers = new HttpHeaders().set('Content-Type', 'application/json');

		return this._http.get(this.url+'prod_showph', {headers: headers});
	} 
	
	// Obtener todos los Productos
	getProductos(): Observable<any>{
		let headers = new HttpHeaders().set('Content-Type', 'application/json');

		return this._http.get(this.url+'prod_showg', {headers: headers});
	} 

	// Obtener todos los Productos habilitados para select
	getProductosl(): Observable<any>{
		let headers = new HttpHeaders().set('Content-Type', 'application/json');

		return this._http.get(this.url+'prod_showsl', {headers: headers});
	}

	//--Consultar productos para select en kardex--//
	getProductsk(): Observable<any>{
		let headers = new HttpHeaders().set('Content-Type','application/json');

		return this._http.get(this.url+'prod_showslk', {headers: headers});
	}
	
	// Obtener todos los Productos habilitados con stock al minimo
	getStockMin(): Observable<any>{
		let headers = new HttpHeaders().set('Content-Type', 'application/json');

		return this._http.get(this.url+'prod_showstm', {headers: headers});
	}

	// Obtener todos los Productos habilitados para select de ventas 
	getProductoslv(): Observable<any>{
		let headers = new HttpHeaders().set('Content-Type', 'application/json');

		return this._http.get(this.url+'prod_showslv', {headers: headers});
	} 

	// Obtener total Productos (habilitados/deshabilitados) para dashboard
	getProductostdh(): Observable<any>{
		let headers = new HttpHeaders().set('Content-Type', 'application/json');

		return this._http.get(this.url+'prod_showtphd', {headers: headers});
	} 

	// Crear plantilla de productos en excel
	getProductospp(): Observable<any>{
		let headers = new HttpHeaders().set('Content-Type', 'application/json');

		return this._http.get(this.url+'prod_showpp', {headers: headers});
	}
	
	// Transacciones de kardex con filtro de fecha y producto
	getKardex(datKdx): Observable<any>{
		let json = JSON.stringify(datKdx);
		let headers = new HttpHeaders().set('Content-Type', 'application/json');

		return this._http.post(this.url+'prod_showkx',json, {headers: headers});
	}

	// Listar Productos excluidos de descuentos
	getProdExDs(): Observable<any>{
		let headers = new HttpHeaders().set('Content-Type', 'application/json');

		return this._http.get(this.url+'prod_showproexds', {headers: headers});
	}
	// Listar todos los productos habilitados y que tengan asignado mas de un almacen*/
	getProductoMultiAm(): Observable<any>{
		let headers = new HttpHeaders().set('Content-Type', 'application/json');

		return this._http.get(this.url+'prod_showproma', {headers: headers});
	}
	//--Consultar stock de un producto por almacen en ventas registradas 
    getStockProAlm(idpro, idalm): Observable<any>{
		let headers = new HttpHeaders().set('Content-Type','application/json');

		return this._http.get(this.url+'prod_showstproal/'+idpro+'/'+idalm, {headers: headers}); 
	}

	//--Consultar planilla
	getPlantilla(): Observable<any>{
		let headers = new HttpHeaders().set('Content-Type', 'application/json');

		return this._http.get(this.url+'prod_showpla', {headers: headers});
	}

	//--Reporte de inventario--//
	getInvProd(paraminv): Observable<any>{
		let json = JSON.stringify(paraminv);
		let headers = new HttpHeaders().set('Content-Type','application/json');

		return this._http.post(this.url+'prod_showrpinv', json, {headers: headers});
	}

	//--Consultar imagen de un Producto específico
    getImgProducto(idp): Observable<any>{
		let headers = new HttpHeaders().set('Content-Type','application/json');

		return this._http.get(this.url+'prod_showima/'+idp, {headers: headers}); 
	}

	//--Consultar tabla de precios de un Producto específico
    getTpProducto(idp): Observable<any>{
		let headers = new HttpHeaders().set('Content-Type','application/json');

		return this._http.get(this.url+'prod_showprecp/'+idp, {headers: headers}); 
	}

	//--Consultar todos los productos que han tenido algun movimiento en sistema
	getProductokx(): Observable<any>{
		let headers = new HttpHeaders().set('Content-Type', 'application/json');

		return this._http.get(this.url+'prod_showprokx', {headers: headers});
	}
}